import { useEffect } from "react"

const useInterval = (fn, time, params: any[] = []) => {
  useEffect(() => {
    const handle = setInterval(fn, time)
    return () => clearInterval(handle)
  }, params)
}

export default useInterval